import React, { useState, useEffect } from "react";
import moment from "moment";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import api from "../../../services/api";
import { IAM_API_BASE_URL_2 } from "../../../services/TapApiUrls";
import Loader from "../../../components/ui/Loader/Loader";
import Status from "../../../components/ui/Status";
import DateService from "../../../services/DateService";
import TapHelper from "../../../services/TapHelper";
import { DisplayListPagination } from "../../../components/TapUi";

const RentalEventListModal = ({ isOpen, selectedDate, rentalType, onClose }) => {
    const [loading, setLoading] = useState(false);
    const [meta, setMeta] = useState({});
    const [events, setEvents] = useState([]);
    const accessToken = useSelector(state => state.auth.access_token);

    useEffect(() => {
        if (isOpen && selectedDate) {
            fetchRentalDetails();
        }
    }, [isOpen, selectedDate]);

    const fetchRentalDetails = async (page = 1) => {
        setLoading(true);
        try {
            const headers = { 'Authorization': 'Bearer ' + accessToken };

            const params = {
                search_date_from: selectedDate,
                search_date_to: selectedDate,
                per_page: 20,
                page: page
            };

            const response = await api.server2Api.get(`${IAM_API_BASE_URL_2}/report/asset_with_rental`, {
                params, headers
            });

            const responseData = response.data || {};
            const rentalData = responseData.data || [];

            setMeta(
                TapHelper.pick(responseData.meta, [
                    'from',
                    'to',
                    'total',
                    'last_page',
                    'per_page',
                    'current_page'
                ])
            );
            let filteredData = rentalData;
            if (rentalType == 'tentative') {
                filteredData = rentalData.filter(item =>
                    item.rental_detail?.date_release_tentative_display
                );
            } else if (rentalType == 'wo_due_date') {
                filteredData = rentalData.filter(item =>
                    item.rental_detail?.wo_due_date_display
                );
            }
            setEvents(filteredData);
        } catch (error) {
            toast.error('Failed to load Rental details');
        } finally {
            setLoading(false);
        }
    };
    const getModalTitle = () => {
        if (rentalType == 'tentative') {
            return `Tentative Details for ${DateService.dateFormat(selectedDate, 'DD MMM YYYY')}`;
        } else if (rentalType == 'wo_due_date') {
            return `WO Due Date Details for ${DateService.dateFormat(selectedDate, 'DD MMM YYYY')}`;
        }
        return `Rental Details for ${DateService.dateFormat(selectedDate, 'DD MMM YYYY')}`;
    };
    const getDateColumn = (event) => {
        if (rentalType == 'tentative') {
            return event?.rental_detail?.date_release_tentative_display || '-';
        } else if (rentalType == 'wo_due_date') {
            return event?.rental_detail?.wo_due_date_display || '-';
        }
        return event?.rental_detail?.wo_due_date_display || '-';
    };
    const getDateColumnLabel = () => {
        if (rentalType == 'tentative') {
            return 'Tentative Release Date';
        } else if (rentalType == 'wo_due_date') {
            return 'WO Due Date';
        }
        return 'WO Due Date';
    };

    if (!isOpen) return null;

    return (
        <div className="modal fade show d-block">
            <div className="modal-dialog modal-lg">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">
                            {getModalTitle()}
                        </h5>
                        <button type="button" className="btn-close" onClick={onClose}></button>
                    </div>
                    <div style={{ maxHeight: "500px", overflowY: "auto" }}>
                        <div className="modal-body">
                            {loading ? (
                                <div className="text-center py-3"><Loader /></div>
                            ) : (
                                <table className="table table-bordered table-sm align-middle bg-white mt-2">
                                    <thead className="align-middle table-secondary">
                                        <tr>
                                            <th scope="col" style={{ width: "5%" }} className="text-center">S.No</th>
                                            <th scope="col" style={{ width: "25%" }}>Asset </th>
                                            <th scope="col" style={{ width: "20%" }}>Site Name</th>
                                            <th scope="col" style={{ width: "20%" }} className="text-center">Commercial Status</th>
                                            <th scope="col" style={{ width: "20%" }} className="text-center">{getDateColumnLabel()}</th>

                                        </tr>
                                    </thead>
                                    <tbody>
                                        {events.length > 0 ? (
                                            events.map((event, index) => (
                                                <tr key={event.id || index}>
                                                    <td className='text-center'>
                                                        {((meta.current_page - 1) * meta.per_page) + index + 1}
                                                    </td>
                                                    <td>{event?.name || '-'}
                                                        {event.asset_code ? ` (${event.asset_code})` : ''}</td>
                                                    <td>{event.site || '-'}</td>
                                                    <td className='text-center'>
                                                        {event?.rental_detail && event?.rental_detail.status_data ? <Status color={event?.rental_detail.status_data.color}>{event?.rental_detail.status_data.name}</Status> : "-"}
                                                    </td>

                                                    <td className='text-center'>
                                                        {getDateColumn(event)}
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td className="text-center" colSpan={7}>No Record Found</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            )}
                            {events.length > 0 && (
                                <DisplayListPagination
                                    meta={meta}
                                    onPageChange={(e) => fetchRentalDetails(e.selected + 1)}
                                />
                            )}
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" onClick={onClose}>Close</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RentalEventListModal;